import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import Map from '../Map';
import { FlexElement, MetricStackTitle, ShinyBlockOuter, ShinyBody, ShinyHeading } from '../../Styles';
import Util from '../../core/Util';

const MapElement = ({site, height = 200}) => {
    const [mapMarkers, setMapMarkers] = useState([[site.map_lat, site.map_long, site.name]]);

    useEffect(()=>{
        setMapMarkers( [[site.map_lat, site.map_long, site.name]] );
    }, [site]);

    if(Util.isMobile()){
        return null;
    }
    
    return <ShinyBlockOuter flexBasis={Util.isMobile()? "95%" : "49%"}>
        <ShinyHeading>
            <MetricStackTitle>Map</MetricStackTitle>
        </ShinyHeading>
        <ShinyBody>
            <Map markers={ mapMarkers } height={height}/>
        </ShinyBody>
    </ShinyBlockOuter>;
}

export default MapElement;